/** Priority green — loud but ~3 steps darker than bright green-500. */
export const PRIORITY_GREEN = {
  bright: "#16A34A",
  sharp: "#15803D",
  dark: "#166534",
  deep: "#14532D",
  bg: "#DCFCE7",
  bgMid: "#BBF7D0",
  border: "#22C55E",
};

export const TODAY_SLOT_ORDER = [
  { key: "11AM-1:30PM", label: "11AM-1:30PM" },
  { key: "2:30-5PM", label: "2:30-5PM" },
  { key: "5-7:30PM", label: "5-7:30PM" },
  { key: "Other", label: "Custom" },
];

/** Order was flagged priority at creation (badge can persist after completion). */
export function isPriorityOrder(order) {
  return Boolean(order?.is_priority);
}

/** Full green tile/theme — active pipeline only; reverts to normal pink when done. */
export function isPriorityOrderActive(order) {
  if (!isPriorityOrder(order)) return false;
  const status = order.status || "";
  return status !== "Completed" && status !== "Delivered";
}

export function priorityAccentClass(active, { pink = "", green = "" } = {}) {
  return active ? green : pink;
}

/** Shared Tailwind bundles for priority accents */
export const priorityClasses = {
  badge: "bg-green-600 text-white",
  badgeSm: "text-[9px] px-1.5 py-0.5 rounded-full font-bold bg-green-600 text-white",
  badgeLg: "text-xs px-2.5 py-1 rounded-full font-extrabold uppercase tracking-wide bg-green-700 text-white shadow-sm",
  accentText: "text-green-700",
  accentTextDark: "text-green-800",
  accentBorder: "border-green-600",
  accentBorderLight: "border-green-500",
  accentBg: "bg-green-50",
  accentBgHover: "hover:bg-green-600",
  statusCurrent: "bg-green-600 text-white border-green-600",
  statusDone: "bg-green-600/10 text-green-800 border-green-400",
  statusHover: "hover:border-green-600 hover:text-green-700",
  card: "order-card-priority bg-green-50 border-green-400 shadow-md hover:shadow-lg border-l-[6px] border-l-green-600",
  cardSpotlight: "order-card-priority order-card-priority-spotlight bg-green-50 border-green-500 shadow-lg hover:shadow-xl border-l-[8px] border-l-green-700",
  topBar: "bg-gradient-to-r from-green-500 to-green-700",
};

export function groupOrdersByDeliverySlot(ordersToGroup) {
  const grouped = {
    "11AM-1:30PM": [],
    "2:30-5PM": [],
    "5-7:30PM": [],
    Other: [],
  };

  (ordersToGroup || []).forEach((order) => {
    const slot = order.delivery_slot;
    if (grouped[slot]) grouped[slot].push(order);
    else grouped.Other.push(order);
  });

  return grouped;
}

export function filterPriorityOrders(orders) {
  return (orders || []).filter(isPriorityOrder);
}

export function formatDeliverySlotLabel(order) {
  if (order?.delivery_slot === "Custom" && order?.custom_time) {
    return order.custom_time;
  }
  return order?.delivery_slot || "—";
}
